import type { FC } from 'react';

import { useProfileModeration } from 'hooks/useProfileModeration';
import { useVerificationEdits } from 'hooks/useVerificationEdits';

import { TutorNotice } from './TutorNotice';

export const ModeratorCommentBanner: FC = () => {
  const { status, comment } = useProfileModeration();
  const { hasRejectedItems } = useVerificationEdits();

  if (!comment?.trim()) {
    return null;
  }

  if (status !== 'rejected' && status !== 'changes_requested') {
    return null;
  }

  const title =
    status === 'rejected' ? 'Профиль отклонен модератором' : 'Нужны изменения';

  return (
    <TutorNotice
      tone='note'
      title={title}
      text={comment.trim()}
      linkTo={hasRejectedItems ? '/teacher/edits' : '/teacher/edit'}
      linkLabel={
        hasRejectedItems ? 'Смотреть замечания модератора' : 'Исправить профиль и отправить снова'
      }
    />
  );
};
